import React from "react";
import Card from "react-bootstrap/Card";
import ShowMoreText from "react-show-more-text";
import projImg11 from "../../assets/img/11.png";
import projectimage10 from "../../assets/img/p10.png";

const PreviousCard10 = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Identifying brand strategy success on social media</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage10} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg11} />{" "}
            <p className="text7">Szilvia Bíró-Szigeti </p>
            <br />
            <p className="text8">
              Associate Professor <br /> Department of Management and
              Business Economics, BME
            </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
              The aim of the project is to identify the brand strategy
              success factors that businesses, organizations and
              individuals use for their appearance on websites and social
              media. This approach involves the identification of brand
              management tools that focuses on the exploration of image
              elements and the analysis of visual applications. We
              primarily aim to analyze the success factors of texts,
              images and videos using advanced natural language processing
              and object identification tools (topic analysis, sentiment
              analysis, optical character recognition, and object
              detection). The results are suitable for identifying the
              marketing communication components of the most popular and
              successful elements (campaigns, news, announcements), their
              rate and timing.
              <br />
              <br />
              Related literature:{" "}
              <ul>
                <li>
                  Lies, J., & Fuß, S. (2019). Factors influencing the
                  success of social media posts: A quantitative analysis
                  of over 60 million Facebook posts.{" "}
                  <span className="text9">
                    Journal of Digital & Social Media Marketing{" "}
                  </span>
                  , 7(2), 137-147.
                </li>
                <li>
                  Jenders, M., Kasneci, G., & Naumann, F. (2013, May).
                  Analyzing and predicting viral tweets. In{" "}
                  <span className="text9">
                    Proceedings of the 22nd international conference on
                    world wide web
                  </span>{" "}
                  (pp. 657-664).
                </li>
                <li>
                  Barnes, K., Riesenmy, T., Trinh, M. D., Lleshi, E.,
                  Balogh, N., & Molontay, R. (2021). Dank or not?
                  Analyzing and predicting the popularity of memes on
                  Reddit.{" "}
                  <span className="text9"> Applied Network Science </span>,
                  6(1), 1-24.
                </li>
                <li>
                  Aaker, D. A. (2011). Building strong brands.
                  <span className="text9"> Free Press </span>.
                </li>
                <li>
                  Kotler, P., Armstrong, G. (2016): Principles of
                  Marketing. 16th Edition, Pearson.
                </li>
              </ul>{" "}
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default PreviousCard10;
